// extracted by mini-css-extract-plugin
module.exports = {"container":"clicklogo-module--container--SASgr","bigb":"clicklogo-module--bigb--3yxdA"};